import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/platform/service-desk')({
  head: () => ({
    ...buildSeoHead({ path: '/platform/service-desk', ...ROUTE_META['/platform/service-desk'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Service Desk', path: '/platform/service-desk' }])),
      jsonLdScript(buildWebPageSchema({ path: '/platform/service-desk', ...ROUTE_META['/platform/service-desk'] })),
    ],
  }),
});
